import { useParams } from 'react-router-dom'

import { Avatar, Box, Button, Text } from '@factorialco/deprecated-design-system'
import { ProjectionKind } from 'generated/resources/datatable.graphql'
import { useWorkingConditionsVersionEmployees } from 'generated/resources/datatable.graphql'

import DataTable from 'modules/core/components/DataTable'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

import DetachedLabel from './DetachedLabel'

const WorkingConditionsVersionEmployees = () => {
  const { navigation } = useNavigation()
  const { identifier } = useParams()

  const source = useWorkingConditionsVersionEmployees(
    [
      {
        identifier: 'avatar',
        kind: ProjectionKind.Decorative,
        fixed: true,
        justifyContent: 'flex-start',
        width: 60,
        render: ({ contractVersion_employee_avatar, contractVersion_employee_firstName }) => (
          <Avatar
            label={contractVersion_employee_firstName || ''}
            url={buildUrl(contractVersion_employee_avatar?.url)}
          />
        ),
      },
      {
        identifier: 'firstName',
        title: i18n.t(
          'company_settings.general.employment_data.work_conditions.fields.employees.columns.first_name'
        ),
        kind: ProjectionKind.Custom,
        sortBy: 'firstName',
        fixed: true,
        render: ({ contractVersion_employee_firstName }) => (
          <Text.Normal weight="medium">{contractVersion_employee_firstName}</Text.Normal>
        ),
        template: '{{contractVersion_employee_firstName}}',
      },
      {
        identifier: 'contractVersion_employee_lastName',
        title: i18n.t(
          'company_settings.general.employment_data.work_conditions.fields.employees.columns.last_name'
        ),
        sortBy: 'lastName',
        kind: ProjectionKind.Custom,
        render: ({ contractVersion_employee_lastName }) => (
          <Text.Normal weight="medium">{contractVersion_employee_lastName}</Text.Normal>
        ),
        template: '{{contractVersion_employee_lastName}}',
      },
      {
        identifier: 'contractVersion_jobTitle',
        title: i18n.t(
          'company_settings.general.employment_data.work_conditions.fields.employees.columns.job'
        ),
        kind: ProjectionKind.Custom,
        render: ({
          contractVersion_jobTitle,
          contractVersion_jobCatalogLevel_name,
          contractVersion_jobCatalogLevel_roleName,
        }) => {
          const title =
            contractVersion_jobTitle ||
            `${contractVersion_jobCatalogLevel_roleName}, ${contractVersion_jobCatalogLevel_name}`
          return (
            <Text.Normal weight="medium" ellipsis title={title}>
              {title}
            </Text.Normal>
          )
        },
        template: '{{contractVersion_jobTitle}}',
      },
      {
        identifier: 'workplace',
        title: i18n.t(
          'company_settings.general.employment_data.work_conditions.fields.employees.columns.workplace'
        ),
        kind: ProjectionKind.Path,
        path: 'contractVersion_employee_locationName',
      },
      {
        identifier: 'conditionsDetached',
        title: i18n.t(
          'company_settings.general.employment_data.work_conditions.fields.employees.columns.conditions_detached'
        ),
        kind: ProjectionKind.Custom,
        render: ({ differentFieldsCount }) => <DetachedLabel count={differentFieldsCount || 0} />,
        template: '{{differentFieldsCount}}',
      },
      {
        identifier: 'link',
        kind: ProjectionKind.Decorative,
        fixed: true,
        justifyContent: 'flex-end',
        width: 80,
        render: ({ contractVersion_employee_id }) => (
          <Button.Router
            aria-label={i18n.t(
              'company_settings.general.employment_data.work_conditions.fields.employees.columns.employeeAgreementLink'
            )}
            to={navigation.employees.id.contractVersions.fullPath({
              id: `${contractVersion_employee_id}`,
            })}
            type="secondary"
            iconName="arrow-right"
          />
        ),
      },
    ],
    {
      variables: {
        versionId: Number(identifier),
      },
    }
  )

  return (
    <Box flexGrow width="full">
      <DataTable
        source={source}
        sort={{
          direction: 'asc',
          path: 'lastName',
        }}
        exportFileName="working-conditions-employees"
        disableExport
      />
    </Box>
  )
}

export default WorkingConditionsVersionEmployees
